import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [cartId, setCartId] = useState(localStorage.getItem("trs_cart_id"));
  const [cart, setCart] = useState({ lines: [], subtotal: 0, itemCount: 0 });
  const [suggestions, setSuggestions] = useState([]);
  const [wgReminder, setWgReminder] = useState([]);
  const [open, setOpen] = useState(false);

  const refreshSuggestions = useCallback(async (id) => {
    if (!id) return;
    try {
      const data = await api.getSuggestions(id);
      setSuggestions(data.suggestions || []);
      setWgReminder(data.whiteGloveReminder || []);
    } catch (e) {}
  }, []);

  useEffect(() => {
    (async () => {
      let id = cartId;
      try {
        const data = id ? await api.getCart(id) : await api.createCart();
        id = data.id;
        setCartId(id);
        localStorage.setItem("trs_cart_id", id);
        setCart(data);
        refreshSuggestions(id);
      } catch (e) {}
    })();
  }, []); // eslint-disable-line

  const sync = (data) => {
    setCart(data);
    refreshSuggestions(data.id);
  };

  const addItem = async (line, { openDrawer = true, silent = false } = {}) => {
    if (!cartId) return;
    const data = await api.addToCart(cartId, line);
    sync(data);
    if (!silent) toast.success("Added to cart");
    if (openDrawer) setOpen(true);
  };

  const addItems = async (lines, { openDrawer = true } = {}) => {
    if (!cartId || !lines.length) return;
    const data = await api.addManyToCart(cartId, lines);
    sync(data);
    toast.success("Bundle added to cart");
    if (openDrawer) setOpen(true);
  };

  const updateItem = async (line) => {
    const data = await api.updateCart(cartId, line);
    sync(data);
  };

  const removeItem = async (line) => {
    const data = await api.removeCart(cartId, line);
    sync(data);
  };

  return (
    <CartContext.Provider
      value={{ cart, cartId, suggestions, wgReminder, open, setOpen,
               addItem, addItems, updateItem, removeItem }}
    >
      {children}
    </CartContext.Provider>
  );
}
